"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
  width: "32",
  height: "32",
  fill: "#fff"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M6.672.6,0,6.956,1.251,8.147,7.3,2.379V17.7H9.07V2.379l6.052,5.768,1.251-1.191L9.7.6A2.22,2.22,0,0,0,6.672.6Z",
  transform: "translate(25.021 8.131) rotate(90)"
})));
module.exports = exports.default;